import { InternalServerErrorException } from '../../../common/exceptions/exceptions';
import { LogManager } from '../../../common/port/log/log.manager.port';
import { GetChallengeInsightProgressFocusV1SummaryApplicationService } from '../../../core/application/services/challenge-insights/get-challenge-insight-progress-focus-v1-summary.application-service';
import { ChallengeInsightProgressFocusV1SummaryAggregateRoot } from '../../../core/domain/aggregates/challenge-insights/challenge-insight-progress-focus-v1.aggregate-root';
import { GetChallengeInsightProgressSummaryRequestDto } from '../../dtos/challenge-insights/get-challenge-insight-progress-summary.request.dto';

export class GetChallengeInsightProgressFocusV1SummaryQuery {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly service: GetChallengeInsightProgressFocusV1SummaryApplicationService
  ) {}
  async execute(
    props: GetChallengeInsightProgressSummaryRequestDto
  ): Promise<ChallengeInsightProgressFocusV1SummaryAggregateRoot> {
    try {
      return await this.service.execute(props);
    } catch (error) {
      throw new InternalServerErrorException(error);
    }
  }
}
